import type { PaymentStatus } from '~domains/transactions/entities/payment';

import type { Merchant } from '~entities/merchant';

import {
  getCorrectDateRange,
  keepExistingIds,
  readPersistedJson,
  writePersistedJson,
} from '~shared/lib/persisted-filters';
import type { DateRange } from '~shared/ui/date-range-picker';

import { endOfDay, startOfDay, subDays } from 'date-fns';

export type PaymentsFiltersValue = {
  period: DateRange;
  merchantIds: string[];
  statuses: PaymentStatus[];
};

export const PAYMENTS_FILTERS_STORAGE_KEY = 'paymentsFilters.v2';

export const DEFAULT_PAYMENTS_PERIOD_DAYS = 7;

export const getDefaultPaymentsFilter = (): PaymentsFiltersValue => ({
  period: {
    startDate: startOfDay(
      subDays(new Date(), DEFAULT_PAYMENTS_PERIOD_DAYS)
    ).toISOString(),
    endDate: endOfDay(new Date()).toISOString(),
  },
  merchantIds: [],
  statuses: [],
});

export const restorePaymentsFilters = (
  merchants: Merchant[]
): PaymentsFiltersValue => {
  const defaults = getDefaultPaymentsFilter();
  const saved = readPersistedJson<Partial<PaymentsFiltersValue>>(
    PAYMENTS_FILTERS_STORAGE_KEY
  );

  if (!saved) {
    return defaults;
  }

  return {
    period: getCorrectDateRange(saved.period, defaults.period),
    merchantIds: keepExistingIds(
      saved.merchantIds,
      merchants.map(({ id }) => id)
    ),
    statuses: saved.statuses ?? [],
  };
};

export const persistPaymentsFilters = (filters: PaymentsFiltersValue) => {
  writePersistedJson(PAYMENTS_FILTERS_STORAGE_KEY, filters);
};
